import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import DateTime from 'react-datetime';
import * as moment from 'moment';
import AsyncSelect from 'react-select/lib/Async';

class MakoRxForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  };

  componentWillMount() {
    const {
      initialValues: { coveredEntityName },
    } = this.props;

    if (coveredEntityName !== null) {
      if (coveredEntityName.toLowerCase() === 'baptist health') {
        this.props.change('coveredEntity', 1);
      }
      else if (coveredEntityName.toLowerCase() === 'williamson health') {
        this.props.change('coveredEntity', 2);
      }
      else if (coveredEntityName.toLowerCase() === 'regenesis healthcare') {
        this.props.change('coveredEntity', 3);
      }
      else if (coveredEntityName.toLowerCase() === 'uk health') {
        this.props.change('coveredEntity', 4);
      }
    }
    this.props.change('intlRxGroup', 'TTVERIFY25');
    this.props.change('intlRxBin', '610269');
    this.props.change('intlRxPCN', 'RXPREF');
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    placeholder,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-6 control-label">{label}</label>
      <div className="col-md-6">
        <input
          {...input}
          className="form-control"
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
        />
        <small className="help-block">{help}</small>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect = ({
    input,
    readOnly,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-6 control-label">{label}</label>
      <div className="col-md-6">
        <select id="select" {...input} className="form-control" disabled={readOnly}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onChange = (e, val) => {
    const select = document.getElementById('select');
    this.props.change('coveredEntityName', select.options[select.selectedIndex].text);

    if (val === '1') {
      this.props.change('rxGroup', '76608001');
      this.props.change('rxBin', '610020');
      this.props.change('rxPCN', 'PDMI340B');
    }
    else if (val === '2') {
      this.props.change('rxGroup', '');
      this.props.change('rxBin', '');
      this.props.change('rxPCN', '');
    }
    else if (val === '3') {
      this.props.change('rxGroup', '76439001');
      this.props.change('rxBin', '610020');
      this.props.change('rxPCN', 'PDMI340B');
    }
    else if (val === '4') {
      this.props.change('rxGroup', 'PRXIHM25');
      this.props.change('rxBin', '022527');
      this.props.change('rxPCN', 'RXPMC');
    }
  }

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-6 control-label">{label}</label>
      <div className="col-md-6">
        <DateTime
          // dateFormat="YYYY-MM-DD"
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : (label === 'date') ? moment().format('MM/DD/YYYY') : null;
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
              // input.onChange(param)
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSpecialProgramsSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-3 control-label">{label}</label>
      <div className="col-md-9">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled
          isMulti
          loadOptions={this.props.searchSpecialPrograms}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Special Program..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onSpecialProgramChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onSpecialProgramChange = (val) => {
    this.props.change('specialPrograms', val);
  }

  submit = values => {
    const { onSubmit } = this.props;
    const actionValues = {};
    actionValues.id = values.id;
    actionValues.channelPartnerMemberId = values.channelPartnerMemberId;
    actionValues.channelPartnerPersonCode = values.channelPartnerPersonCode;
    actionValues.makoPartner = values.makoPartner;
    actionValues.coveredEntityName = values.coveredEntityName;
    actionValues.rxGroup = values.rxGroup;
    actionValues.rxBin = values.rxBin;
    actionValues.rxPCN = values.rxPCN;
    actionValues.intlRxGroup = values.intlRxGroup;
    actionValues.intlRxBin = values.intlRxBin;
    actionValues.intlRxPCN = values.intlRxPCN;
    actionValues.thirdPartyAdministratorName = values.thirdPartyAdministratorName;
    actionValues.hcbbClientId = values.hcbbClientId;
    actionValues.hcbbGroupId = values.hcbbGroupId;
    actionValues.hcbbSiteId = values.hcbbSiteId;
    actionValues.ihmMemberId = values.ihmMemberId;
    actionValues.ihmStartDate = values.ihmStartDate;
    actionValues.ihmEndDate = values.ihmEndDate;
    actionValues.intlStartDate = values.intlStartDate;
    actionValues.intlEndDate = values.intlEndDate;
    //actionValues.optiMedStartDate = values.optiMedStartDate;
    //actionValues.optiMedEndDate = values.optiMedEndDate;
    //actionValues.aphoraStartDate = values.aphoraStartDate;
    //actionValues.aphoraEndDate = values.aphoraEndDate;
    //actionValues.specialPrograms = values.specialPrograms;
    return onSubmit(actionValues);
  };

  renderPartnersSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-6 control-label">{label}</label>
      <div className="col-md-6">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchMakoRxPartners}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Partner..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onPartnerChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onPartnerChange = (val) => {
    this.props.change('makoPartner', val);
  }

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      isLoading,
      isExecutive,
    } = this.props;

    return (
      <form className="makorx-form" onSubmit={handleSubmit(this.submit)}>
        <fieldset>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <Field
                  className="form-control"
                  name="channelPartnerMemberId"
                  component={this.renderField}
                  type="text"
                  label="Channel Partner Member ID"
                />
                <Field
                  className="form-control"
                  name="channelPartnerPersonCode"
                  component={this.renderField}
                  type="text"
                  maxLength={2}
                  label="Channel Partner Person Code"
                />
                <Field
                  name="makoPartner"
                  component={this.renderPartnersSelect}
                  label="Channel Partner Name"
                />
                <Field
                  className="form-control"
                  name="coveredEntity"
                  component={this.renderSelect}
                  label="Covered Entity Name"
                  onChange={this.onChange}
                >
                  <option value="-1">Select</option>
                  <option value="1">Baptist Health</option>
                  <option value="2">Williamson Health</option>
                  <option value="3">Regenesis Healthcare</option>
                  <option value="4">UK Health</option>
                </Field>
                <Field
                  className="form-control"
                  name="intlRxGroup"
                  component={this.renderField}
                  type="text"
                  label="INTL Rx Group"
                />
                <Field
                  className="form-control"
                  name="intlRxBin"
                  component={this.renderField}
                  type="text"
                  label="INTL Rx BIN"
                />
                <Field
                  className="form-control"
                  name="intlRxPCN"
                  component={this.renderField}
                  type="text"
                  label="INTL Rx PCN"
                />
                <Field
                  className="form-control"
                  name="intlStartDate"
                  component={this.renderDateField}
                  type="text"
                  label="INTL Start Date"
                />
                <Field
                  className="form-control"
                  name="intlEndDate"
                  component={this.renderDateField}
                  type="text"
                  label="INTL End Date"
                />
                <Field
                  className="form-control"
                  //name="thirdPartyAdministratorName"
                  component={this.renderField}
                  type="text"
                  placeholder="See Client Manager..."
                  disabled
                  label="OptiMed Subgroup/TPA"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <Field
                  className="form-control"
                  name="hcbbClientId"
                  component={this.renderField}
                  type="text"
                  label="HCBB Client ID"
                />
                <Field
                  className="form-control"
                  name="hcbbGroupId"
                  component={this.renderField}
                  type="text"
                  label="HCBB Group ID"
                />
                <Field
                  className="form-control"
                  name="hcbbSiteId"
                  component={this.renderField}
                  type="text"
                  label="HCBB Site ID"
                />
                <Field
                  className="form-control"
                  name="ihmMemberId"
                  component={this.renderField}
                  type="text"
                  label="Internal PRX Member ID"
                />
                <Field
                  className="form-control"
                  name="rxGroup"
                  component={this.renderField}
                  type="text"
                  label="IHM Rx Group"
                />
                <Field
                  className="form-control"
                  name="rxBin"
                  component={this.renderField}
                  type="text"
                  label="IHM Rx BIN"
                />
                <Field
                  className="form-control"
                  name="rxPCN"
                  component={this.renderField}
                  type="text"
                  label="IHM Rx PCN"
                />
                <Field
                  className="form-control"
                  name="ihmStartDate"
                  component={this.renderDateField}
                  type="text"
                  placeholder="Date"
                  label="IHM Start Date"
                />
                <Field
                  className="form-control"
                  name="ihmEndDate"
                  component={this.renderDateField}
                  type="text"
                  placeholder="Date"
                  label="IHM End Date"
                />
                {/*<Field*/}
                {/*  className="form-control"*/}
                {/*  name="optiMedStartDate"*/}
                {/*  component={this.renderDateField}*/}
                {/*  type="text"*/}
                {/*  placeholder="Date"*/}
                {/*  label="OptiMed Start Date"*/}
                {/*/>*/}
                {/*<Field*/}
                {/*  className="form-control"*/}
                {/*  name="optiMedEndDate"*/}
                {/*  component={this.renderDateField}*/}
                {/*  type="text"*/}
                {/*  placeholder="Date"*/}
                {/*  label="OptiMed End Date"*/}
                {/*/>*/}
                {/*<Field*/}
                {/*  className="form-control"*/}
                {/*  name="aphoraStartDate"*/}
                {/*  component={this.renderDateField}*/}
                {/*  type="text"*/}
                {/*  placeholder="Date"*/}
                {/*  label="Aphora Start Date"*/}
                {/*/>*/}
                {/*<Field*/}
                {/*  className="form-control"*/}
                {/*  name="aphoraEndDate"*/}
                {/*  component={this.renderDateField}*/}
                {/*  type="text"*/}
                {/*  placeholder="Date"*/}
                {/*  label="Aphora End Date"*/}
                {/*/>*/}
                
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <Field
                  name="specialPrograms"
                  component={this.renderSpecialProgramsSelect}
                  label="Special Programs"
                />
              </div>
            </div>
          </div>
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-sm-12">
              <button
                type="button"
                className="btn btn-default"
                disabled={submitting}
              >
                Cancel 
              </button>
              &nbsp;
              <button
                type="submit"
                className="btn btn-primary"
                disabled={pristine || submitting || isExecutive}
              >
               Save
              </button>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="cover">
            <div className="spinner inline" />
          </div>
        )}
      </form>
    );
  }
}
const validate = (values, props) => {
  const errors = {};
  
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {
      id: ownProps.makoRx.id,
      channelPartnerMemberId: ownProps.makoRx.channelPartnerMemberId,
      channelPartnerPersonCode: ownProps.makoRx.channelPartnerPersonCode,
      makoPartner: ownProps.makoRx.makoPartner,
      coveredEntityName: ownProps.makoRx.coveredEntityName,
      rxGroup: ownProps.makoRx.rxGroup,
      rxBin: ownProps.makoRx.rxBin,
      rxPCN: ownProps.makoRx.rxPCN,
      intlRxGroup: ownProps.makoRx.intlRxGroup,
      intlRxBin: ownProps.makoRx.intlRxBin,
      intlRxPCN: ownProps.makoRx.intlRxPCN,
      thirdPartyAdministratorName: ownProps.makoRx.thirdPartyAdministratorName,
      hcbbClientId: ownProps.makoRx.hcbbClientId,
      hcbbGroupId: ownProps.makoRx.hcbbGroupId,
      hcbbSiteId: ownProps.makoRx.hcbbSiteId,
      ihmMemberId: ownProps.makoRx.ihmMemberId,
      ihmStartDate: ownProps.makoRx.ihmStartDate,
      ihmEndDate: ownProps.makoRx.ihmEndDate,
      intlStartDate: ownProps.makoRx.intlStartDate,
      intlEndDate: ownProps.makoRx.intlEndDate,
      //optiMedStartDate: ownProps.makoRx.optiMedStartDate,
      //optiMedEndDate: ownProps.makoRx.optiMedEndDate,
      //aphoraStartDate: ownProps.makoRx.aphoraStartDate,
      //aphoraEndDate: ownProps.makoRx.aphoraEndDate,
      specialPrograms: ownProps.makoRx.specialPrograms
    },
    validate,
    form: `makoRxForm_${ownProps.makoRx.id}`
  };
}
export default compose(
  connect(mapStateToProps),
  reduxForm({
    //other redux-form options...
  })
)(MakoRxForm);




// WEBPACK FOOTER //
// ./src/routes/management/components/MakoRxForm.js